import { MarkovState } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setMarkovStateList = (stateList: types.MarkovStateList) => ({
    type: inferLiteral(types.MARKOV_STATE_LIST),
    stateList,
})
export const setMarkovStateIds = (stateIds: readonly number[]) => ({
    type: inferLiteral(types.MARKOV_STATE_IDS),
    stateIds,
})
export const setMarkovStateEdit = (state: MarkovState) => ({
    type: inferLiteral(types.MARKOV_STATE_EDIT),
    state,
})
export const setMarkovStateSort = (sortColumn: keyof MarkovState, sortOrder: OrderType) => ({
    type: inferLiteral(types.MARKOV_STATE_SORT),
    sortColumn,
    sortOrder,
})
export const setMarkovStateFilters = (filters: types.MarkovStateFilters) => ({
    type: inferLiteral(types.MARKOV_STATE_FILTERS),
    filters,
})
export const setMarkovStateReloadList = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_STATE_RELOAD_LIST),
    value,
})
export const setMarkovStateReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_STATE_RELOAD_EDIT),
    value,
})
